import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { SessionModel } from "@/api/user/user.types";
import useModalRouter from "@/hooks/useModalRouter";
import { cn } from "@/utils/cn.ts";

interface SessionDeviceProps {
  session: SessionModel;
}

const SessionDevice = ({ session }: SessionDeviceProps): JSX.Element => {
  const { t } = useTranslation();

  const date = new Date(session.updated);

  const formattedDate = date.toLocaleDateString("ru", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const { openModal } = useModalRouter();

  return (
    <li
      className={
        "flex flex-row items-center justify-between gap-4 rounded-[0.938rem] bg-surface-bright p-5 max-md:flex-col"
      }
    >
      <div className={"flex flex-col gap-[0.313rem] max-md:items-center"}>
        <p
          className={cn("text-lg font-semibold  leading-6", {
            "before:top-50 relative pl-5 before:absolute before:-left-0 before:top-1/2 before:block before:h-[0.625rem] before:w-[0.625rem] before:-translate-y-1/2 before:transform before:rounded-full before:bg-orange-1":
              session.is_current,
          })}
        >
          {session.ua_browser_name}, {session.ua_os_name} {session.ua_os_version}
        </p>
        <p className={"leading-[1.313rem] text-grey-1 max-md:text-center"}>
          {session.is_current && `${t("Sessions.current")} /`} {t("General.time-date")}: {formattedDate}
        </p>
      </div>
      {!session.is_current && (
        <Button
          size={"medium"}
          color={"black"}
          aria-label={t("Sessions.end")}
          onClick={() => {
            openModal(MODAL_ROUTES.DELETE_SESSION, { session_id: session.my_key });
          }}
          className={"max-w-56 max-md:max-w-none lg:bg-transparent"}
        >
          {t("Sessions.end")}
        </Button>
      )}
    </li>
  );
};

export default SessionDevice;
